<template>
  <div>
    <QueryFrame
      :count="count"
      :current="page"
      :add-text="handlePermission('supplierPrimaryKeyAdd') ? '编辑供应商主键' : ''"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      @addNew="addNew">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>供应商编码:</label>
            <lk-input class="item" v-model.trim="query.queryCode" clearable></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch(false, pollingData)">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>

    <operate-log v-model="showLog" :logList="logData"/>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import toolsService from '../../services/tools';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import OperateLog from '../../components/operateLog';

// 接口信息
export default {
  name: 'SupplierPrimaryKey',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    OperateLog,
  },
  data() {
    return {
      query: {
        queryCode: '', // 供应商编码
      },
      showLog: false,
      timer: null,
      statusMap: new Map([
        [1, '成功'],
        [2, '失败'],
        [3, '修改中...'],
      ]),
      columns: [
        { title: '供应商编码', key: 'code', minWidth: 116 },
        {
		    	title: '修改进度',
          key: 'status',
          minWidth: 116,
			    render: (h, { row }) => h('span', {
			    	class: {
			    		error: row.status === 2,
            },
          }, this.statusMap.get(row.status)),
        },
        { title: '供应商名称', key: 'name', minWidth: 116 },
        { title: '社会统一信用代码', key: 'creditCode', minWidth: 116 },
        { title: '最后更新人', key: 'createUserName', minWidth: 116 },
        { title: '最后更新时间', key: 'createTime', minWidth: 116 },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, { row }) => (this.hasEditable ? h('lk-button', {
            props: {
              type: 'text',
              disabled: row.doubtfulCount === 0,
            },
            on: {
              click: () => {
                this.handleLog(row.code);
              },
            },
          }, '操作日志') : null),
        },
      ],
      tableData: [],
      logData: [],
    };
  },
  computed: {
    hasEditable() {
      return this.handlePermission('supplierPrimaryKeyOperateLog');
    },
  },
  methods: {
    handleReset() {
      this.query = {};
    },
    getData(loading) {
      return new Promise((resolve) => {
        this.params.page = this.page;
        this.params.size = this.size;
        this.$store.commit('setDisableLoading', loading);
        toolsService.getSupplierPrimaryList(this.params).then((res) => {
          if (res.data.status === 200) {
            const { count, list } = res.data.data;
            list.forEach((item) => {
              item.createTime = utils.exchangeTime(item.createTime); // 创建时间
            });
            this.count = count;
            this.tableData = list;
            resolve(list);
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    addNew() {
      this.$router.push({ name: 'supplierPrimaryKeyAdd' });
    },
    handleLog(code) {
      this.logData = [];
      this.showLog = true;
      this.$store.commit('setDisableLoading', true);
      toolsService.getSupplierPrimaryOperationLogList({ code }).then((res) => {
        if (res.data.status === 200) {
          const data = res.data.data;
          const logItem = {
            content: `${utils.formatTime(data.createTime)}由 ${data.createUserName} ${data.contentList.join(';')}`,
          };
          this.logData.push(logItem);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // 轮询修改结果
    pollingData() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData(true).then((data) => {
          this.tableData = data;

          // 没有数据或者都是完成状态
          if (data.every(item => item.status === 1)) {
          	clearInterval(this.timer);
          }
        });
      }, 5000);
    },

  },
  created() {
    if (!this.hasEditable) {
      this.columns.pop();
    }
    this.handleSearch(true, this.pollingData);
  },
  destroyed() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="less" scoped>
  .error {
    color: #ed4014;
  }
</style>
